<template>
    <div style="direction: rtl">
        <!--    <div-->
        <!--      v-if="!dataLoaded"-->
        <!--      style="display: flex; width: 100vw; height: 100vh; align-items: center"-->
        <!--    >-->
        <!--      <ProgressSpinner-->
        <!--        style="width: 100px; height: 100px"-->
        <!--        strokeWidth="3"-->
        <!--        animationDuration="2s"-->
        <!--        v-if="!dataLoaded"-->
        <!--      />-->
        <!--    </div>-->
        <!--    <Skeleton borderRadius="34px" class="p-skeleton p-p-6" height="100rem" width="100rem" v-if="!dataLoaded"/>-->
        <BlockUI style="padding-bottom: 70px" :blocked="!dataLoaded">
            <Panel
                    :class="presenceShowClass" class="p-as-center p-shadow-10  p-fluid" header="דוח נוכחות" :toggleable="true">
                <!--    <Card  class="p-as-center p-shadow-15 p-m-2 p-fluid">-->
                <!--      <template #content>-->
                <transition class="" appear name="slide-fade">
                    <div class="p-jc-around p-grid p-p-3">
                        <select-grade class="p-col-12 p-md-5 p-lg-5"  use-store storage-name="presence" defaultFirst v-model="selectedGrade" navigate-buttons></select-grade>
<!--                        <div class="p-col-12 p-md-5 p-lg-5">-->
<!--                            <div class="p-inputgroup">-->
<!--                                <Button-->
<!--                                        v-tooltip.top="'הכיתה הקודמת'"-->
<!--                                        @click="navigateGrades(false)"-->
<!--                                        icon="pi  pi-angle-up"-->
<!--                                        class="-->
<!--                    button-grade-back-->
<!--                    p-inputgroup-addon-->
<!--                    plus-->
<!--                    p-button-secondary p-inputgroup-addon-->
<!--                  "-->
<!--                                ></Button>-->

<!--                                <Dropdown-->
<!--                                        style="text-align: center"-->
<!--                                        filterPlaceholder=" חפש לפי כיתה"-->
<!--                                        emptyFilterMessage=" לא נמצא שם כיתה תואם"-->
<!--                                        :filter="true"-->
<!--                                        class=""-->
<!--                                        optionLabel="hebrewName"-->
<!--                                        v-model="selectedGrade"-->
<!--                                        :options="gradeOptions"-->
<!--                                        placeholder="בחר כיתה"-->
<!--                                        data-key="id"-->
<!--                                        @input="componentKey++, (update = 0)"-->
<!--                                >-->
<!--                                    <template #value="slotProps">-->
<!--                                        <div v-if="slotProps.value">-->
<!--                                            <span>{{ slotProps.value.hebrewName }}</span>-->
<!--                                        </div>-->
<!--                                        <span v-else>-->
<!--                      {{ slotProps.placeholder }}-->
<!--                    </span>-->
<!--                                    </template>-->
<!--                                    <template #option="slotProps">-->
<!--                                        <span>{{ slotProps.option.hebrewName }}</span>-->
<!--                                    </template>-->
<!--                                </Dropdown>-->

<!--                                <Button-->
<!--                                        v-tooltip.top="'הכיתה הבאה'"-->
<!--                                        @click="navigateGrades(true)"-->
<!--                                        icon="pi  pi-angle-down"-->
<!--                                        class="plus p-button-secondary p-inputgroup-addon"-->
<!--                                ></Button>-->
<!--                            </div>-->
<!--                        </div>-->

                        <div class="p-col-12 p-md-5 p-lg-6">
                            <div class="p-inputgroup">
                                <Button
                                        v-tooltip.top="'היום הקודם'"
                                        @click="addOrSubDayToDate(false)"
                                        icon="pi pi-angle-right"
                                        class="minus p-button-secondary p-inputgroup-addon"
                                ></Button>

                                <Calendar
                                        :width="{ display }"
                                        style="text-align: center !important"
                                        class="calendar-hebrew calendar-picker-presence"
                                        v-on:date-select="convertFullDateToDate"
                                        :manualInput="false"
                                        :disabledDays="[6]"
                                        v-model="selectedDate"
                                        :showButtonBar="true"
                                        :dateFormat="dateformat"
                                />

                                <Button
                                        v-tooltip.top="'היום הבא'"
                                        @click="addOrSubDayToDate(true)"
                                        icon="pi  pi-angle-left"
                                        class="plus p-button-secondary p-inputgroup-addon"
                                ></Button>
                            </div>
                    <div v-if="!isCurrentDay" class="subject-tracking t-warning message-warning">
<i class="p-message-icon pi pi-exclamation-triangle p-pl-3"></i>
                                <h3 >שים לב, זה לא התאריך של היום</h3>
                            </div>
                        </div>
                        <count-pupil-bar :key="countComponentKey" :pupils="pupilsSort" :dataObj="dataForPupilsCount()" class="p-col-9"/>
                    </div>

                </transition>

                <div id="table"
                     class="p-p-1">

                    <div class="p-p-1">
                        <div class="card p-grid">
                            <div class="p-col-3"></div>
                            <!-- phone-->
                            <div
                                    @click="dialogStudyAdd(time)"
                                    v-tooltip.top="studyTitle(time)"
                                    class="p-d-md-none p-col time-header"
                                    :class="{ 'time-header-fulled': isStudyExist(time.id) }"
                                    v-for="time in lessonTime"
                                    :key="`${time.id}-phone`"
                            >
                                <h4 class="p-d-md-none">{{ time.id }}</h4>
                            </div>
                            <!-- pc -->
                            <div
                                    @click="dialogStudyAdd(time)"
                                    class="
                  time-header
                  p-d-none p-d-md-inline-flex p-col p-jc-center
                "
                                    v-tooltip.top="studyTitle(time)"
                                    :class="{ 'time-header-fulled': isStudyExist(time.id) }"
                                    v-for="time in lessonTime"
                                    :key="`${time.id}-pc`"
                            >
                                <div class="p-d-flex p-flex-column">
                                    <h4 class="p-d-md-none p-d-md-inline">{{ time.hebrewName }}</h4>
<!--                                    <h4 style="" class="p-d-md-none p-d-md-inline">&#45;&#45;</h4>-->
                                    <h4 style="background-color: rgba(144,255,163,0.34);"
                                        class="p-d-md-none p-d-md-inline">{{ getScheduleTeacher(time.id) }}</h4>
                                    <h4 style="background-color: rgba(144, 170 ,255, 0.34);"
                                        class="p-d-md-none p-d-md-inline">{{ getScheduleSubject(time.id) }}</h4>
                                </div>

                            </div>

                        </div>
                    </div>


                    <div
                            class="p-p-1 p-grid"
                            v-for="(pupil, pupilIndex) in pupilsSort"
                            :key="`a-${pupilIndex}`"
                    >
                        <!-- phone -->
                        <div
                                @click="dialogTracingAdd(pupil)"
                                v-tooltip.top="
                `דיווח התנהגות
                  ${pupil.firstname && pupil.firstname}  ${pupil.lastname && pupil.lastname}`
              "
                                :style="`background-color: ${getEmptyColor(pupilIndex)}`"
                                class="name-col p-d-md-none p-col-3"
                        >
                            <Badge
                                    v-tooltip.top=" `  אירועים שלא טופלו `"
                                    v-if="pupil &&  tracingActive[pupil.id] > 2"
                                    :value="pupil && tracingActive[pupil.id]"
                                    severity="danger">

                            </Badge>
                            <h5 class="p-d-md-none">
                                {{ pupil && pupil.lastname }} {{pupil && pupil.firstname && pupil.firstname[0] }}.
                            </h5>
                        </div>

                        <!-- pc -->
                        <div :style="`background-color: ${getEmptyColor(pupilIndex)}`"
                             class="name-col p-d-none p-d-md-inline-flex p-col-3 p-ai-center">

                            <div
                                    @click="moveToTrack(pupil.id)">
                                <Badge

                                        v-tooltip.top=" `  אירועים שלא טופלו `"
                                        v-if="pupil && tracingActive[pupil.id] > 2"
                                        :value="pupil && tracingActive[pupil.id]"
                                        severity="danger">

                                </Badge>
                            </div>

                            <div
                                    @click="dialogTracingAdd(pupil)"
                                    v-tooltip.top="`דיווח התנהגות`"
                                    class="p-grid p-jc-center p-col"
                            >
                                <h4 class="p-d-md-none p-d-md-inline-flex">
                                    {{ pupil && pupil.lastname && pupil.lastname }}
                                    {{ pupil && pupil.firstname && pupil.firstname }}
                                </h4>

                            </div>

                        </div>


                        <!-- presence-->

                        <div
                                id="empty-col"
                                class="empty p-col p-p-0"
                                v-bind:style="`background-color: ${getEmptyColor(pupilIndex)}`"
                                @click="changeStatus(pupil, time, $event)"
                                v-tooltip.top="getStatusTitle(time, pupil)"
                                v-for="(time, index) in lessonTime"
                                :key="index"
                        >
                            <transition-group
                                    appear
                                    name="staggered-fade"
                                    v-bind:css="false"
                                    @before-enter="beforeEnter"
                                    @enter="enter"
                            >
                                <div
                                        v-if="
                    isPresenceExist(time.id, pupil.id, index) && showAllPresence
                  "
                                        id="presence-col"
                                        class="p-col p-p-0 presence-col"
                                        :data-index="index"
                                        :key="update"
                                        v-bind:style="`background-color: ${presenceColor(
                    time.id,
                    pupil.id,
                    index
                  )}`"
                                        style="width: 100vm; height: 100%"
                                ></div>
                            </transition-group>
                        </div>

                        <!--            </div>-->
                    </div>

                </div>

                <!--      </template>-->
                <!--    </Card>-->
            </Panel>

        </BlockUI>
<!--        <div v-if="dataLoaded" style="display: flex; justify-content: center">-->
<!--            <Button-->
<!--                    label="דיווח ציוני מבחן"-->
<!--                    class="p-button-warning p-m-3"-->
<!--                    icon="pi pi-pencil"-->
<!--                    iconPos="left"-->
<!--                    @click="isDialogTestAdd = true"-->
<!--            />-->
<!--        </div>-->
        <!--      <div style=" position: relative;" v-else>-->
        <!--/*            <ProgressBar mode="indeterminate" style="height: .5em ;  display: block;"/>*/-->
        <!--        />-->

        <ChangeDialog
                ref="child"
                :show="isDialogAdd"
                :pupil="pupil"
                :time="time"
                :date="selectedDate"
                :selectedPresence="selectedPresence"
                v-on:closeDialog="selectedPresence = null"
                v-on:updateItem="updateItem"
                v-on:addItem="addItem"
                v-on:removeItem="removeItem"
        >
        </ChangeDialog>
<!--        <AddTestDialog-->
<!--                :show="isDialogTestAdd"-->
<!--                v-on:closeDialog="isDialogTestAdd = false"-->
<!--        >-->
<!--        </AddTestDialog>-->
        <StudyShortDialog
                :studObjSelected="studObjSelected"
                :show="isDialogStudyAdd"
                :date="selectedDate"
                :grade="selectedGrade"
                :lessonTime="lessonTimeSelected"
                :subjectLessonSchedule="subjectLessonSchedule"
                v-on:closeDialog="
        () => {
          isDialogStudyAdd = false;
        }
      "
                v-on:resetStudSelected="studObjSelected = null"
                v-on:postStudy="postStudy"
                v-on:deleteStudy="deleteStudy"
        >
        </StudyShortDialog>
        <TracingShortDialog
                :show="isDialogTracingAdd"
                :date="selectedDate"
                :grade="selectedGrade"
                :pupil="selectedPupil"
                v-on:closeDialog="isDialogTracingAdd = false"
                v-on:updateTracking="updateTracingActive"
        >

        </TracingShortDialog>
    </div>
</template>

<script>
import _groupBy from "lodash/groupBy";
// import AddTestDialog from "../../dialogs/mainPost/TestMultyDialog";

import {dateToFullHebrew, getTime} from "../../utils/hebrewDateFormat";
import _mapValues from "lodash/mapValues";
import Service from "../../service/Service";
import ChangeDialog from "../../dialogs/PresenceChangeDialog.vue";
import StudyShortDialog from "../../dialogs/StudyShortDialog";
import TracingShortDialog from "../../dialogs/TracingShortDialog";
import {mapState} from "vuex";
import Vue from "vue";
import {getLessonShortName, getTeacherShortName} from "@/utils/parseObj";
import CountPupilBar from "@/views/Home/countPupilBar";
import SelectGrade from "@/components/selects/SelectGrade";


export default {
    service: null,
    components: {
        SelectGrade,
        CountPupilBar,

        ChangeDialog,
        StudyShortDialog,
        TracingShortDialog,
        // AddTestDialog,
    },

    created() {

        window.addEventListener("resize", this.onResize);
        this.service = new Service();
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.onResize);
    },
    mounted() {
        if (this.isStateReady) {
        //     if (this.user.grade !== null) {
        //         this.selectedGrade = this.getGradeObj(this.user.grade);
        //     } else {
        //         this.selectedGrade = this.gradeOptions[0];
        //     }
            this.init();
        }
    },
    watch: {
        selectedDate() {
            this.init();
        },
        selectedGrade() {
            this.init();
        },
        user(newCount, oldCount) {
            if (newCount.grade !== null) {
                this.selectedGrade = this.getGradeObj(this.user.grade);
            }
        },
        gradeOptions(newCount, oldCount) {
            if (this.user.grade !== null) {
                this.selectedGrade = this.getGradeObj(this.user.grade);
            }
        },
    },
    data() {
        return {
            showAllPresence: true,
            colsRender: null,
            tracingActive: {},
            studObjSelected: null,
            isDialogTestAdd: false,
            displayPosition: true,
            update: 0,
            lessonTimeSelected: null,
            presencesLoaded: false,
            studsLoaded: false,
            rowShow: 0,
            rowColor: 0,
            componentKey: 0,
            showPresence: true,
            pupil: null,
            pupilArray: [],
            time: null,
            timeArray: [],
            selectedGrade: null,
            selectedPresence: null,
            selectedPresenceArray: [],
            selectedPupil: null,
            isDialogAdd: true,
            isDialogChange: false,
            selectedDate: new Date(),
            finalObj: {},
            pupilsFilter: null,
            data: null,
            loading: false,
            isDialogStudyAdd: false,
            isDialogTracingAdd: false,
            finalPresencesObj: null,
            finalStudsObj: null,
            scheduleGradeDay: {},
            subjectLessonSchedule: null,
            countComponentKey : 0,
            display: "40vw",
        };
    },

    computed: {
        isCurrentDay(){
            return this.isToday(this.selectedDate)
        },
        presenceShowClass(){
            if (this.isCurrentDay === false){
                return 'not-current-day'
            }
        },
        dateformat() {
            return dateToFullHebrew(this.selectedDate);
        },
        dataLoaded() {
            return this.presencesLoaded && this.studsLoaded;
        },
        pupilsSort() {
            if (this.selectedGrade !== null) {
                // return this.pupils
                return this.pupils?.filter((p) => p?.grade?.id === this.selectedGrade?.id);
            }
        },
        ...mapState([
            "pupils",
            "user",
            "teachers",
            "lessonTime",
            "subjectLesson",
            "presenceStatus",
            "isStateReady",
            "gradeOptions",
        ]),
    },
    methods: {
         isToday(date) {
    const today = new Date();

    // 👇️ Today's date
    console.log(today);

    if (today.toDateString() === date.toDateString()) {
        return true;
    }

    return false;
},
        dataForPupilsCount() {
            if (this.selectedDate && this.finalPresencesObj) {
                const today = `${this.selectedDate.getDate()}.${this.selectedDate.getMonth() + 1 % 12}.${this.selectedDate.getFullYear()}`
                const todayPresences = this?.finalPresencesObj?.[today]
                let filterPresences = []
                let pupilsGrade = this.pupils?.filter((p) => p?.grade?.id === this.selectedGrade?.id);
                if (this.selectedGrade !== null) {
                    if (todayPresences) {
                        Object.values(todayPresences).forEach((obj) => {
                            if (obj) {
                                Object.keys(obj).forEach(function (presencePupilId) {
                                    if (pupilsGrade && pupilsGrade.some(p => p.id === presencePupilId)) {
                                        filterPresences.push(obj[presencePupilId])
                                    }
                                });
                            }
                        })
                    }
                }

                return filterPresences
            }
        },
        getScheduleTeacher(id) {
            const teacherId = this.scheduleGradeDay[id]?.teacher
            if (teacherId) {
                return getTeacherShortName(teacherId)
            }
        },
        getScheduleSubject(id, returnFullObj = false) {

            const subjectId = this.scheduleGradeDay[id]?.subject
            if (subjectId) {
                if (returnFullObj) {
                    return subjectId
                } else {
                    return getLessonShortName(subjectId)
                }
            }
        },
        applyUpdateTracingActive() {
            this.updateTracingActive()
        },
        onResize() {
            alert;
            if (window.innerWidth < 576) {
                this.display = "40vw";
            } else {
                this.display = "10px";
            }
        },
        navigateGrades(isAdd) {
            const index = this.gradeOptions.findIndex(
                (grade) => grade.id === this.selectedGrade.id
            );
            this.selectedGrade =
                this.gradeOptions[
                ((isAdd ? index + 1 : index - 1) + this.gradeOptions.length) %
                this.gradeOptions.length
                    ];

            this.showAllPresence = false;
            setTimeout(() => (this.showAllPresence = true), 25);
        },
        convertDateToLng(date) {
            const dates = date.split(".");
            const finalDate = `${dates[2]}-${dates[1]}-${dates[0]}`;
            const parse = Date.parse(finalDate);
            return parse;
        },
        addOrSubDayToDate(isAdd) {
            const newDate = new Date(Date.parse(this.selectedDate));
            isAdd
                ? newDate.setDate(newDate.getDate() + 1)
                : newDate.setDate(newDate.getDate() - 1);
            if (newDate.getDay() === 6) {
                isAdd
                    ? newDate.setDate(newDate.getDate() + 1)
                    : newDate.setDate(newDate.getDate() - 1);
            }

            // this.selectedDate = new Date().toLocaleDateString().split("T")[0];
            // this.selectedDate = newDate.toLocaleDateString().split("T")[0];
            this.selectedDate = newDate;

            this.showAllPresence = false;
            this.countComponentKey ++

            setTimeout(() => (this.showAllPresence = true), 20);
        },
        beforeEnter(el) {
            if (this.update === 0) {
                el.style.opacity = 0;
                el.style.width = 0;
            }
        },
        enter(el, done) {
            if (this.update === 0) {
                var delay = el.dataset.index * 100;
                setTimeout(function () {
                    Velocity(
                        el,
                        {opacity: 1, width: "100%"},
                        {duration: 150},
                        {complete: done}
                    );
                }, delay);
            }
        },
        postStudy(studyObj) {
            if (
                this.finalStudsObj[this.convertMillisecondsToString(studyObj.date)] ===
                undefined
            ) {
                this.finalStudsObj[this.convertMillisecondsToString(studyObj.date)] = {
                    [studyObj.date]: {},
                };
            }
            if (
                this.finalStudsObj[this.convertMillisecondsToString(studyObj.date)][
                    studyObj.grade.id
                    ] === undefined
            ) {
                this.finalStudsObj[this.convertMillisecondsToString(studyObj.date)][
                    studyObj.grade.id
                    ] = {
                    [studyObj.grade.id]: {},
                };
            }
            // if (this.finalStudsObj[studyObj.date][studyObj.grade.id][studyObj.time.id] === undefined) {
            //   this.finalStudsObj[studyObj.date][studyObj.grade.id][studyObj.time.id] = {[studyObj.time.id]: {}}
            // }
            this.finalStudsObj[this.convertMillisecondsToString(studyObj.date)][
                studyObj.grade.id
                ][studyObj.time.id] = [];
            this.finalStudsObj[this.convertMillisecondsToString(studyObj.date)][
                studyObj.grade.id
                ][studyObj.time.id].push(studyObj);
            // this.finalStudsObj[]
            this.studObjSelected = null;

            this.componentKey++;
            this.update++;
        },
        moveToTrack(pupilId) {
            this.$router.push({name: 'tracing', query: {pupil: pupilId, onlyAlert: true}})
        },
        deleteStudy(studyObj) {
            delete this.finalStudsObj[
                this.convertMillisecondsToString(studyObj.date)
                ][studyObj.grade.id || studyObj.grade][studyObj.time.id || studyObj.time];
            this.componentKey++;
            this.update++;
        },
        getEmptyColor(index) {
            let emptyColor;
            index % 2 === 0 ? (emptyColor = `#e3ddcf`) : (emptyColor = `#fffdf8`);
            return emptyColor;
        },
        dialogStudyAdd(time) {
            this.subjectLessonSchedule = null
            if (this.isStudyExist(time.id)) {
                this.studObjSelected = this.studyObj(time.id);
            }
            this.lessonTimeSelected = time;
            this.subjectLessonSchedule = this.getScheduleSubject(time.id, true)
            this.isDialogStudyAdd = true;
        },
        dialogTracingAdd(pupil) {
            this.selectedPupil = pupil;
            this.isDialogTracingAdd = true;
        },
        convertFullDateToDate(date) {
            // this.selectedDate = date.toLocaleDateString();
        },
        showTrackCount(pupilId) {
            // this.tracingActive?.find(track => track.id === pupilId)?.count
        },
        async updateTracingActive() {
            try {
                const {data} = await this.service.getTracingActive(this.selectedGrade.id)
                const object = data.reduce(
                    (obj, item) => Object.assign(obj, {[item.id]: item.count}), {});

                this.tracingActive = object
            } catch (e) {
                console.log(e)
            }
        },
        async updateSchedule() {
            const gradeId = this?.selectedGrade.id
            const day = new Date(this.selectedDate).getDay()

            try {
                const data = await this.service.getAllScheduleByGradeAndDay(day, gradeId)
                const scheduleObj = {}
                if (data.length > 0) {
                    data.forEach((schedule) => {
                        scheduleObj[schedule._id.lesson] = {
                            teacher: schedule.teacher,
                            subject: schedule.subject
                        }
                    })
                }

                this.scheduleGradeDay = scheduleObj
            } catch (e) {
                console.log(e)
            }
        },
        async init() {
            // study loading
            this.studsLoaded = false;
            this.presencesLoaded = false;
            this.updateTracingActive()
            this.updateSchedule()
            this.service.getStudyByDateAndByGrade(this.selectedDate.getTime(),
                this.selectedGrade.id).then((data) => {
                this.studsLoaded = true;
                data.forEach((element) => {

                    element.user = this.getTeacherObj(element.user);
                    element.subject = this.getSubjectStudObj(element.subject);
                    element.date = new Date(JSON.parse(element.date))
                        .toLocaleDateString()
                        .split("T")[0];
                });
                const dates = _groupBy(data, (obj) => obj.date);
                const byGrade = _mapValues(dates, (date) =>
                    _groupBy(date, (obj) => obj.grade)
                );
                this.finalStudsObj = _mapValues(byGrade, (grade) =>
                    _mapValues(grade, (obj) => _groupBy(obj, (obj2) => obj2?.time))
                );

            });

            // presence loading
            // this.service.get("presence").then((data) => {
            this.service.getPresenceByDateAndByGrade(this.selectedDate.getTime(),
                this.selectedGrade.id).then((data) => {
                this.presencesLoaded = true;

                data.forEach((element) => {
                    let date
                    if (!element.color){
                       date =  new Date(JSON.parse(element.date))
                            .toLocaleDateString()
                            .split("T")[0];
                    } else {
                        let dayOfWeek = new Date(this.selectedDate)?.getDay();
                        dayOfWeek++
                        if (!element?.daysInWeek?.includes(dayOfWeek)){
                            return
                        }
                        date = new Date(this.selectedDate).toLocaleDateString()
                            .split("T")[0];

                    }
                    element.pupil = this.getPupilObj(element.pupil);
                    element.time = this.getTimeObj(element.time);
                    element.status = element.status ? this.getStatusObj(element.status) : {hebrewName: element.description ,color: `#${element.color}`};
                    element.originalDate = element.date
                    element.date = date

                });
                const dates = _groupBy(data, (obj) => obj.date);

                const byTime = _mapValues(dates, (date) =>
                    _groupBy(date, (obj) => obj.time.id)
                );

                this.finalPresencesObj = _mapValues(byTime, (time) =>
                    _mapValues(time, (obj) => _groupBy(obj, (obj2) => obj2.pupil?.id))
                );
                this.countComponentKey ++
                this.componentKey++

            });

            this.countComponentKey ++
            this.componentKey++
        },
        updateItem(item) {
            this.selectedPresence = null;

            this.finalPresencesObj[
                this.convertMillisecondsToString(this.selectedDate)
                ][item.time.id][item.pupil.id][0] = item;
            this.removeAnotherPresences(item);

            this.componentKey++;
            this.countComponentKey ++
            this.update++;
        },
        addItem(item) {
             item.originalDate = item.date
            item.time = this.getTimeObj(item.time);
            item.status = this.getStatusObj(item.status);
            item.pupil = this.getPupilObj(item.pupil);
            // item.date = new Date(JSON.parse(item.date))
            // .toLocaleDateString()
            // .split("T")[0];
            if (
                this.finalPresencesObj[
                    this.convertMillisecondsToString(this.selectedDate)
                    ] === undefined
            ) {
                this.finalPresencesObj[
                    this.convertMillisecondsToString(this.selectedDate)
                    ] = {[this.convertMillisecondsToString(this.selectedDate)]: {}};
            }
            if (
                this.finalPresencesObj[
                    this.convertMillisecondsToString(this.selectedDate)
                    ][item.time.id] === undefined
            ) {
                this.finalPresencesObj[
                    this.convertMillisecondsToString(this.selectedDate)
                    ][item.time.id] = {
                    [item.time.id]: {},
                };
            }
            if (
                this.finalPresencesObj[
                    this.convertMillisecondsToString(this.selectedDate)
                    ][item.time.id][item.pupil.id] === undefined
            ) {
                this.finalPresencesObj[
                    this.convertMillisecondsToString(this.selectedDate)
                    ][item.time.id][item.pupil.id] = {[item.pupil.id]: {}};
            }
            this.finalPresencesObj[
                this.convertMillisecondsToString(this.selectedDate)
                ][item.time.id][item.pupil.id] = [];
            this.finalPresencesObj[
                this.convertMillisecondsToString(this.selectedDate)
                ][item.time.id][item.pupil.id].push(item);

            this.removeAnotherPresences(item);

            this.countComponentKey ++
            this.componentKey++;
            this.update++;
        },
        removeAnotherPresences(item) {
            if (item.status.id < 0) {
                const presencesIdsToDelete = [];
                this.lessonTime.forEach((lesson) => {
                    if (lesson.id !== "1") {
                        // if (this.finalDataObj[this.selectedDate][lesson.id]) {
                        if (
                            this.finalPresencesObj[
                                this.convertMillisecondsToString(this.selectedDate)
                                ]?.[lesson.id]?.[item.pupil.id]
                        ) {
                            const presenceToDelete =
                                this.finalPresencesObj[
                                    this.convertMillisecondsToString(this.selectedDate)
                                    ][lesson.id][item.pupil.id][0];
                            delete this.finalPresencesObj[
                                this.convertMillisecondsToString(this.selectedDate)
                                ][lesson.id][item.pupil.id];
                            presencesIdsToDelete.push(presenceToDelete.id);
                        }
                        // }
                    }
                });
                presencesIdsToDelete.forEach((presenceId) =>
                    this.service.delete(presenceId, "presence")
                );
            }
        },
        removeItem(item) {
            this.selectedPresence = null;
            delete this.finalPresencesObj[
                this.convertMillisecondsToString(this.selectedDate)
                ][item.time.id][item.pupil.id];

            this.countComponentKey ++
            this.componentKey++;
            this.update++;
        },
        changeStatus(pupil, time, event) {
            this.pupil = pupil;
            this.time = time;

            if (
                this.finalPresencesObj?.[
                    this.convertMillisecondsToString(this.selectedDate)
                    ]?.["1"]?.[pupil.id]?.[0]?.status?.id < 0 &&
                time.id !== "1"
            ) {
                return
            }

            const isConstPresent = this.finalPresencesObj?.[
                this.convertMillisecondsToString(this.selectedDate)
                ]?.[time.id]?.[pupil.id]?.[0]?.color
            if (
                typeof isConstPresent === "string"
            ) {
                return
            }

            if (
                this.finalPresencesObj[
                    this.convertMillisecondsToString(this.selectedDate)
                    ]
            ) {
                if (
                    this.finalPresencesObj[
                        this.convertMillisecondsToString(this.selectedDate)
                        ][time.id]
                ) {
                    if (
                        this.finalPresencesObj[
                            this.convertMillisecondsToString(this.selectedDate)
                            ][time.id][pupil.id]
                    ) {
                        this.selectedPresence =
                            this.finalPresencesObj[
                                this.convertMillisecondsToString(this.selectedDate)
                                ][time.id][pupil.id][0];
                        this.selectedPresence.date = Date.parse(this.selectedDate);
                    }
                }
            }
                Vue.nextTick(() => {
                    this.$refs.child.$refs.op.toggle(event);
                });
        },
        presenceColor(lessonId, pupilId, index) {
            let color = ``;
            const date = this.convertMillisecondsToString(this.selectedDate)
            color =
                this.finalPresencesObj?.[date]?.[lessonId]?.[pupilId]?.[0]?.status?.color;

            if (
                this.finalPresencesObj?.[date]
            ) {
                if (
                    this.finalPresencesObj?.[date]["1"]
                ) {
                    if (
                        this.finalPresencesObj?.[date]["1"][pupilId]
                    ) {
                        if (
                            this.finalPresencesObj?.[date]["1"][pupilId][0].status.id < 0
                        ) {
                            color =
                                this.finalPresencesObj?.[date]["1"][pupilId][0].status.color;
                        }
                    }
                }
            }

            return color;
        },
        convertMillisecondsToString(date) {
            return new Date(date).toLocaleDateString().split("T")[0];
        },
        isPresenceExist(lessonId, pupilId, index) {
            if (
                this.finalPresencesObj?.[
                    this.convertMillisecondsToString(this.selectedDate)
                    ]?.["1"]?.[pupilId]?.[0]?.status.id < 0
            ) {
                return true;
            }
            return (
                this.finalPresencesObj?.[
                    this.convertMillisecondsToString(this.selectedDate)
                    ]?.[lessonId]?.[pupilId] !== undefined
            );
        },
        isStudyExist(lessonId) {
            return (
                this.finalStudsObj?.[
                    this.convertMillisecondsToString(this.selectedDate)
                    ]?.[this.selectedGrade.id]?.[lessonId] !== undefined
            );
        },
        studyObj(lessonId) {
            if (this.isStudyExist(lessonId)) {
                return this.finalStudsObj?.[
                    this.convertMillisecondsToString(this.selectedDate)
                    ]?.[this.selectedGrade.id]?.[lessonId]?.[0];
            }
        },
        studyTitle(lesson) {
            if (this.isStudyExist(lesson.id)) {
                const studyObj = this.studyObj(lesson.id);
                if (studyObj) {
                    return `${studyObj.subject?.hebrewName || "-"} ${
                        !studyObj.content ? "" : `\n${studyObj?.content}`
                    }\n ${studyObj.user?.firstname} ${studyObj.user?.lastname} `;
                }
            } else {
                return ` דווח התקדמות בלימוד
        ${lesson.hebrewName}
        ${this.getScheduleTeacher(lesson.id) || "-"}
        ${this.getScheduleSubject(lesson.id) || "-"}
        `;
            }
        },
        getStatusTitle(lesson, pupil) {
            let presence =
                this.finalPresencesObj?.[
                    this.convertMillisecondsToString(this.selectedDate)
                    ]?.[lesson.id]?.[pupil.id]
            let status = "";

            let  time = ""
            if (presence !== undefined){
                console.log(presence)

                time = getTime(presence?.[0]?.originalDate)
            }
            status = `${pupil.firstname} ${pupil.lastname} \n ${time} `;

            let statusHebrewName = presence?.[0]?.status?.hebrewName;
            if (statusHebrewName) status += `\n ${statusHebrewName}`;
            return status;
        },
        getPupilObj(pupilId) {
            if (this.pupils !== null) {
                return this.pupils.find((pupil) => pupil.id === pupilId);
            }
        },
        getTimeObj(timeId) {
            return this.lessonTime.find((lessonTime) => lessonTime.id === timeId);
        },
        getSubjectStudObj(studId) {
            return this.subjectLesson.find(
                (subjectLesson) => subjectLesson.id === studId
            );
        },
        getTeacherObj(teacherId) {
            return this.teachers.find((teacher) => teacher.id === teacherId);
        },
        getStatusObj(statusId) {
            return this.presenceStatus.find(
                (presenceStatus) => presenceStatus.id === statusId
            );
        },
        getGradeObj(gradeId) {
            if (this.gradeOptions !== null) {
                return this.gradeOptions.find((grade) => grade.id === gradeId);
            }
        },
        openNotification(
            color,
            title,
            text,
            position = "right-left",
            duration = 3000
        ) {
            this.$vs.notification({
                color,
                position,
                title,
                text,
                duration,
                progress: "auto",
            });
        },
    },
};
</script>

<style scoped>
::v-deep .p-fluid .p-calendar .p-inputtext {
    text-align: center !important;
}

.button-grade-back {
    border-top-left-radius: 0 !important;
    border-bottom-left-radius: 0 !important;
    border-top-right-radius: 3px !important;
    border-bottom-right-radius: 3px !important;
}

.p-inputgroup .p-inputtext,
.p-fluid .p-inputgroup .p-inputtext,
.p-inputgroup .p-inputwrapper,
.p-fluid .p-inputgroup .p-input {
    /*width: 100% !important;*/
}

.p-inputgroup .p-inputtext,
.p-fluid .p-inputgroup .p-inputtext,
.p-inputgroup .p-inputwrapper,
.p-fluid .p-inputgroup .p-input {
    /*width: 100% !important;*/
}

.slide-fade-enter-active {
    transition: all 0.5s ease;
}

>>>.not-current-day .p-panel-content{
    background-color: #ffbdbd
}
.slide-fade-leave-active {
    transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter, .slide-fade-leave-to
    /* .slide-fade-leave-active below version 2.1.8 */
{
    transform: translateY(-30px);
    opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
{
    opacity: 0;
}

.p-fluid .p-calendar {
    /*direction: ltr !important;*/
}

h4 {
    text-align: center !important;
}

h5 {
    text-align: center !important;
}

.message-warning{

    margin-top: 10px;
    width: 100%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 10px;

}

.time-header {
    background-image: radial-gradient(#fcebbd, #ffd264);

    /*background-color: #f6d683;*/
    border: 1px solid rgba(132, 128, 128, 0.69);
}

.time-header-fulled {
    /*background-color: #e2d776;*/
    background-image: radial-gradient(#eaf8b3, #b1db6d);
}

.time-header-fulled:hover {
    /*background-color: #e2d776;*/
    /*filter: brightness(1.04);*/

    /*background-image: radial-gradient(  #eaf8b3, #dbbc6d);*/
}

.time-header:hover {
    cursor: pointer;
    filter: contrast(130%);

    border: 1px solid rgba(132, 128, 128, 0.69);
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 3px 10px 0 rgba(0, 0, 0, 0.19);
    transform: scale(1.1, 1.1);
    z-index: 3;
}

.presence-col:hover {
    filter: brightness(1.04);
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 3px 10px 0 rgba(0, 0, 0, 0.19);
    /*transform: scale(1.1, 1.1);*/
    /*background-color: #ffffff;*/
    /*z-index: 3;*/
    /*transform: scale(1.05)*/
}

.name-col {
    /*border-top: 1px solid rgba(132,128,128,0.69);*/
    /*border-bottom: 1px solid rgba(132,128,128,0.69);*/
    /*background-color: rgb(255, 255, 255) !important;*/
    border: 1px solid rgba(132, 128, 128, 0.69);
}

.name-col:hover {
    cursor: pointer;
    background: var(--primary-color) !important;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 3px 10px 0 rgba(0, 0, 0, 0.19);
    border: 1px solid rgba(132, 128, 128, 0.69);
    z-index: 3;
    transform: scale(1.1, 1.1);
    /*filter: brightness(1.04);*/
    filter: contrast(130%);
}

ul {
    list-style: none;
}

.empty-name-1 {
    background-color: #f6e4b7 !important;
    border: 1px solid rgba(132, 128, 128, 0.69);
}

.empty-name-1:hover {
    cursor: pointer;

    background-color: #ffbf18 !important;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 3px 10px 0 rgba(0, 0, 0, 0.19);
    border: 1px solid rgba(132, 128, 128, 0.69);
    z-index: 3;
    transform: scale(1.1, 1.1);
}

.empty {
    border: 1px solid rgba(132, 128, 128, 0.69);
}

.empty:hover {
    border: 1px solid rgba(132, 128, 128, 0.69);
    transform: scale(1.1, 1.1);
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 3px 10px 0 rgba(0, 0, 0, 0.19);

    filter: brightness(1.04);
}

.loading {
    filter: brightness(0.50);
}

.p-datepicker-trigger {
    border-radius: 0px !important;
}
</style>
